import {
    Timeline, TimelineItem, TimelineOppositeContent, TimelineSeparator, TimelineConnector, TimelineContent
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import { formatDateTime } from '@utils/helpers';
import ContactAuditDot from '@components/contact/ContactAuditDot';
import ContactAuditAction from '@components/contact/ContactAuditAction';

const ContactAudits = ({ audits, showDetails, reloadContact, autoOpenId = null, ...params }) => {

    const auditsOnlyWhenShowDetails = ['start_new_process', 'change_pointer', 'change_data', 'change_extra'];

    return (
        <Timeline
            sx={{
                [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.33,
                },
            }} {...params}>
            {audits.map((audit, index) => (
                !showDetails && auditsOnlyWhenShowDetails.includes(audit.action) ? null :
                    <TimelineItem key={index}>
                        <TimelineOppositeContent variant="body2" color="textSecondary" sx={{ pt: 3.3 }}>
                            {formatDateTime(audit.created_at)}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineConnector />
                            <ContactAuditDot audit={audit} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ pt: 2.9 }}>
                            <ContactAuditAction 
                                audit={audit} 
                                showDetails={showDetails} 
                                autoOpenDetails={autoOpenId && audit.id === autoOpenId} 
                                reloadContact={reloadContact} />
                        </TimelineContent>
                    </TimelineItem>
            ))}
        </Timeline>
    );
};

export default ContactAudits;